__turbopack_context__.v({
  "highlight_child": "Safety-module-scss-module__tXh7Ra__highlight_child",
  "safety_first_sec": "Safety-module-scss-module__tXh7Ra__safety_first_sec",
  "safety_sec_content": "Safety-module-scss-module__tXh7Ra__safety_sec_content",
  "safety_sec_content_card": "Safety-module-scss-module__tXh7Ra__safety_sec_content_card",
  "speciality_sec": "Safety-module-scss-module__tXh7Ra__speciality_sec",
  "top_sec": "Safety-module-scss-module__tXh7Ra__top_sec",
});
